module.exports = __webpack_public_path__ + "static/media/4.b1d3b668.svg";